import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProjectCard } from 'legacyComponents/cards/types/project';

import { clientStore } from 'apps/client/app';
import { MainWrapper } from 'legacyComponents/styled/lib';

import { conf } from 'apps/profile/config.yaml';

const ProfileProjects = props => {
  const { appManager, t } = props;
  const { profile, projectsConn } = appManager;
  const projects = projectsConn.arrayApp;

  const { canUpdate, fullName } = profile;
  const {
    inSpace: { whichTypes },
  } = profile;
  const displayName = fullName.split(' ')[0];

  return (
    <MainWrapper>
      <CardSection
        invisible={appManager.loading}
        title={conf.sections[0]}
        tooltip={t('Create new project')}
        updateHeader={true}
        index={1}
        createHandler={
          whichTypes.includes('Space')
            ? () => clientStore.routerStore.navigate('home.newProject')
            : () => ''
        }
        owner={canUpdate}
        ownerName={displayName}
        cardApp={projects}
        CardComponent={ProjectCard}
        noDataCardType='project'
        gridColumns={3}
        canShowNoDataCard
      />
    </MainWrapper>
  );
};

ProfileProjects.propTypes = {
  routeName: PropTypes.string,
  params: PropTypes.object,
  t: PropTypes.func,
  appManager: PropTypes.object,
};

export default withNamespaces()(observer(ProfileProjects));
